var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'w-[130%] ml-[calc(-50vw+74%)] md:w-[100vw] md:ml-[calc(-50vw+50%)]': !_vm.block.nearSidebar && !_vm.isMainPage}},[_c('NewsCatalog',{attrs:{"add-link":_vm.newsAddLink,"items-detail-link":false,"list-query-params":{
            sourceIds: _vm.sourceIds
        },"categories-query-params":{
            sourceIds: _vm.sourceIds
        },"full-width":_vm.fullWidth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }